import { TableCell, TableSortLabel } from "@mui/material"

export function SortableTableCell({ field, label, sortField, sortDirection, onSort, ...props }) {
    const active = sortField === field

    return (
        <TableCell sortDirection={active ? sortDirection : false} {...props}>
            <TableSortLabel active={active} direction={active ? sortDirection : "asc"} onClick={handleClick}>
                {label}
            </TableSortLabel>
        </TableCell>
    )

    function handleClick() {
        onSort(field)
    }
}
